import JobZImage from "../../../../common/jobz-img";
import SectionJobsSidebar2 from "../../sections/jobs/sidebar/section-jobs-sidebar2";
import { useEffect } from "react";
import {enLangTranslation, loadScript, uaLangTranslation} from "../../../../../globals/constants";
import ApplyJobPopup from "../../../../common/popups/popup-apply-job";
import ContactForm from "../../../../common/contact-form";

function JobDetail1Page() {

    const sidebarConfig = {
        showJobInfo: false,
        jobTitle: "Recruiter",
    }

    useEffect(()=>{
        loadScript("js/custom.js");
    })

    const lang = localStorage.getItem('language') || 'en';
    const uaLang = uaLangTranslation;
    const enLang = enLangTranslation;
    const translation = lang === 'en' ? enLang : uaLang;

    return (
        <>
            {/* Job Detail V.2 START */}
            <div className="section-full  p-t100 p-b90 bg-white">
                <div className="container">
                    {/* BLOG SECTION START */}
                    <div className="section-content">
                        <div className="twm-job-self-wrap twm-job-detail-v2">
                            <div className="twm-job-self-info">
                                <div className="twm-job-self-top">
                                    <div className="twm-media-bg">
                                        <div className="twm-jobs-category green"><span className="twm-bg-green">New</span></div>
                                    </div>
                                    <div className="twm-mid-content">
                                        <h4 className="twm-job-title">{translation.vacancies[0].title}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="twm-job-detail-2-wrap">
                            <div className="row d-flex justify-content-center">
                                <div className="col-lg-4 col-md-12 rightSidebar">
                                    <SectionJobsSidebar2 _config={sidebarConfig} />
                                </div>
                                <div className="col-lg-8 col-md-12">
                                    {/* Candidate detail START */}
                                    <div className="cabdidate-de-info">
                                        <h4 className="twm-s-title m-t0">{translation.vacancies[0].who.title}</h4>
                                        <p>{translation.vacancies[0].who.description}</p>
                                        <h4 className="twm-s-title m-t0">{translation.vacancies[0].client.title}</h4>
                                        <p>{translation.vacancies[0].client.description}</p>
                                        <h4 className="twm-s-title">{translation.vacancies[0].responsibilities.title}</h4>
                                        <ul className="description-list-2">
                                            {translation.vacancies[0].responsibilities.items.map((item, index) => (
                                                <li key={index}><i className="feather-check" />{item}</li>
                                            ))}
                                        </ul>
                                        <h4 className="twm-s-title">{translation.vacancies[0].requirements.title}</h4>
                                        <ul className="description-list-2">
                                            {translation.vacancies[0].requirements.items.map((item, index) => (
                                                <li key={index}><i className="feather-check" />{item}</li>
                                            ))}
                                        </ul>
                                        <h4 className="twm-s-title">{translation.vacancies[0].offer.title}</h4>
                                        <ul className="description-list-2">
                                            {translation.vacancies[0].offer.items.map((item, index) => (
                                                <li key={index}><i className="feather-check" />{item}</li>
                                            ))}
                                        </ul>
                                        <h4 className="twm-s-title">{translation.vacancies[0].stages.title}</h4>
                                        <p>{translation.vacancies[0].stages.subtitle}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ContactForm />

                </div>
            </div>
            {/* Job Detail V.2 END */}


            <ApplyJobPopup />
        </>
    )
}

export default JobDetail1Page;